import React, { Component } from 'react';
import { observable, action, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from '@reach/router';
import { keys } from 'lodash';

import { makeRequest, errorResponse } from 'js/services/Network';
import { lightGrey3Color } from 'js/config/style';

import LoadingSpinner from '../../LoadingSpinner';
import Container from './Container';
import Title from './Title';
import Content from './Content';
import Display from './Display';
import Label from './Label';
import Image from './Image';
import LogoIcon from './LogoIcon';

@observer
export default class CreditCard extends Component {
  constructor(props) {
    super(props);
    this.load(props.load);
  }

  @observable error = null;
  @observable isLoading = true;
  @observable.ref data = null;

  hasLoadProps = () =>
    keys(this.props.load || {}).reduce((hasLoadProps, prop) => hasLoadProps && !!this.props.load[prop], true);

  @action async load(props) {
    if (this.hasLoadProps()) {
      this.isLoading = true;
      this.error = null;

      try {
        const data = (await makeRequest('admin-credit-card-data', null, props)).data;
        runInAction(() => (this.data = data));
      } catch (error) {
        runInAction(() => (this.error = errorResponse(error)));
      }

      runInAction(() => (this.isLoading = false));
    } else {
      this.error = 'Could not load credit card';
      this.isLoading = false;
    }
  }

  render() {
    const data = this.data;

    return (
      <Container mode={this.isLoading ? 'loading' : this.error ? 'error' : 'display'}>
        {this.isLoading ? (
          <LoadingSpinner padding="1rem" />
        ) : this.error ? (
          <>
            <Display>
              <LogoIcon name="credit-card" color={lightGrey3Color} />
            </Display>
            <Title>{this.props.title || 'Credit card'}</Title>
            <Content>{this.error}</Content>
          </>
        ) : (
          <>
            <Display>
              <Image src={`/images/payment-icons/${data.credit_card_type}.png`} />
            </Display>
            <Title>
              <Link to={`/admin/credit_cards/credit_card/${data.id}`}>{this.props.title || 'Credit card'}</Link>
            </Title>
            <Content>
              <Label>Credit card</Label>
              <div>
                <Link to={`/admin/credit_cards/credit_card/${data.id}`}>{data.credit_card}</Link>
              </div>

              <Label>Owner</Label>
              <div>
                <div>
                  <Link to={`/admin/users/user/${data.user_email}`}>{data.user_name}</Link>
                </div>
                <div>{data.user_address}</div>
              </div>
            </Content>
          </>
        )}
      </Container>
    );
  }
}
